import { ButtonCore, ButtonCoreBaseProps, ButtonCoreWithoutSelectedProps } from './ButtonCore';
import {
  OmakasePolymorphicComponent,
  OmakasePolymorphicComponentProps,
} from '../utils/OmakasePolymorphicComponent';
import Anchor from 'components/Anchor';
import React from 'react';

// Export props for use when IconButton is nested in another Omakase component
// For IconButton specifically, aria-label is required.
export type IconButtonProps = ButtonCoreBaseProps &
  ButtonCoreWithoutSelectedProps & {
    'aria-label': string;
  };

const IconButtonDefaultElement = 'button';
type IconButtonTypeGuard = 'button' | typeof Anchor;

const IconButton: OmakasePolymorphicComponent<
  IconButtonProps,
  typeof IconButtonDefaultElement,
  IconButtonTypeGuard
> = React.forwardRef(
  <E extends React.ElementType = typeof IconButtonDefaultElement>(
    {
      children,
      component,
      ...rest
    }: OmakasePolymorphicComponentProps<IconButtonProps, E, IconButtonTypeGuard>,
    ref: React.Ref<HTMLButtonElement> | undefined
  ) => {
    const Component: React.ElementType = component || IconButtonDefaultElement;

    return (
      <ButtonCore iconOnly ref={ref} component={Component} {...rest}>
        {children}
      </ButtonCore>
    );
  }
);

export default IconButton;
